<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá criar uma nova seleção, que contempla os campos
              básicos de inscrição e a análise de perfil comportamental DISC.
              Para isso é necessário preencher as informações inicias abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row">
        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Nova seleção</h3>
                </div>
              </div>
            </div>
            <template>
              <form class="vld-parent" @submit.prevent>
                <h6 class="heading-small text-muted mb-4">
                  Informações básicas
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <div>
                        <base-input
                          label="Título da seleção"
                          v-model="model.title"
                          placeholder="Ex. Seleção Trainee"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">
                        Status da chamada
                        <i
                          v-if="model.status"
                          class="fas fa-info-circle ml-1"
                          :title="getStatusDescription"
                        ></i>
                      </label>
                      <div>
                        <base-input addon-left-icon="fas fa-cogs">
                          <select class="form-control" v-model="model.status">
                            <option selected disabled value="">
                              Selecione o status da chamada
                            </option>
                            <option
                              v-for="s in status"
                              :key="s.key"
                              :value="s.key"
                            >
                              {{ s.value }}
                            </option>
                          </select>
                        </base-input>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Link externo (opcional)"
                        v-model="model.external_link"
                        placeholder="Insira o link aqui"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label"
                        >Data para o início das aplicações
                        <base-button
                          size="sm"
                          type="link"
                          class="p-0 m-0 ml-2"
                          @click="setCurrentDate()"
                        >
                          Usar data atual
                        </base-button></label
                      >
                      <base-input
                        type="date"
                        addon-left-icon="ni ni-calendar-grid-58"
                        placeholder="Data início"
                        input-classes="form-control"
                        v-model="model.start_date"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label"
                        >Data para o fim das aplicações (opcional)</label
                      >
                      <base-input
                        addon-left-icon="ni ni-calendar-grid-58"
                        type="date"
                        placeholder="Data fim"
                        input-classes="form-control"
                        v-model="model.end_date"
                      />
                    </div>
                    <div class="col-12 text-right mt--3">
                      <span class="duration">
                        {{ calcDuration() }}
                      </span>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
                <h6 class="heading-small text-muted mb-4">
                  Informações complementares (opcional)
                </h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <div>
                        <base-input
                          label="Região"
                          v-model="model.region"
                          placeholder="Digite um local"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <base-input
                        label="Palavras-chaves"
                        placeholder="Separe-os por ;"
                        input-classes="form-control"
                        v-model="model.keywords"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input label="Descrição">
                        <textarea
                          rows="3"
                          class="form-control form-control"
                          placeholder="Descreva os detalhes para a inscrição no programa"
                          v-model="model.description"
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <base-input label="Observações">
                        <textarea
                          rows="3"
                          class="form-control form-control"
                          placeholder="Escreva aqui as observações"
                          v-model="model.observation"
                        >
                        </textarea>
                      </base-input>
                    </div>
                    <div class="col-lg-12">
                      <base-input label="Mensagem de finalização">
                        <textarea
                          rows="3"
                          class="form-control form-control"
                          placeholder="Escreva aqui a mensagem a ser exibida após a inscrição ser concluída"
                          v-model="model.finished_message"
                        >
                        </textarea>
                      </base-input>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
        </div>
        <div class="col-xl-4 order-xl-1 mb-5 mb-xl-0 mt-6 mt-xl-0">
          <div class="card card-profile shadow">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <img src="/img/pages/call.png" class="rounded-circle" />
                </div>
              </div>
            </div>
            <div class="card-header text-center border-0">
              <div class="d-flex justify-content-between"></div>
            </div>
            <div class="card-body pt-5 pb-4">
              <div class="row">
                <div class="col-12">
                  <div
                    class="card-profile-stats d-flex justify-content-center mt-4"
                  >
                    <div>
                      <span class="heading text-capitalize">{{
                        getStatusName
                      }}</span>
                      <span class="description">Status</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <h3>
                  Região:
                  <span class="font-weight-light">
                    {{ model.region || "..." }}</span
                  >
                </h3>
                <h3>
                  <span v-if="model.end_date">
                    Período das aplicações:
                    <span class="font-weight-light">
                      {{
                        model.start_date
                          ? formatDate(model.start_date, "ll")
                          : "..."
                      }}
                      até
                      {{ formatDate(model.end_date, "ll") }}
                    </span>
                  </span>
                  <span v-else>
                    Início das aplicações:
                    <span class="font-weight-light">
                      {{
                        model.start_date
                          ? formatDate(model.start_date, "ll")
                          : "..."
                      }}
                      <span v-if="model.start_date"> (fluxo contínuo)</span>
                    </span>
                  </span>
                </h3>
                <hr class="my-4" />
                <h2 class="text-center tag-title">
                  <i class="ni ni-tag"></i>
                  <span class="tag">{{ model.title }}</span>
                </h2>
                <div class="col-12 text-center" v-if="error">
                  <base-alert type="danger">{{ error }}</base-alert>
                </div>
                <base-button
                  type="danger"
                  :custom="true"
                  @click="handleOpenModalConfirmation()"
                  >Criar seleção</base-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal
        :show.sync="modals.confirmation"
        modal-classes="modal-default modal-dialog-centered"
      >
        <h6 slot="header" class="modal-title" id="modal-title-notification">
          Atenção!
        </h6>
        <div class="vld-parent" ref="modal_confirmation_create">
          <div class="py-3 text-center">
            <i class="fa fa-bullhorn fa-3x"></i>
            <h4 class="heading mt-4">Confirmar criação de nova seleção</h4>
            <p>
              Você realmente deseja criar a seleção
              <b class="font-weight-bold">{{ model.title }}</b
              >?
            </p>
            <p class="text-sm mt-3 mx-2">
              <i class="fas fa-info-circle mr-1"></i> Lembre-se, uma seleção com
              status 'Regular' fica visível e aceita inscrições.
            </p>
          </div>
        </div>
        <template slot="footer">
          <base-button
            type="link"
            text-color="white"
            class="ml-auto"
            @click="modals.confirmation = false"
          >
            Voltar
          </base-button>
          <base-button type="white" @click="handleSubmit()">
            Confirmar
          </base-button>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import api from "@/services/api.js";

export default {
  name: "selecao-form",
  data() {
    return {
      model: {
        title: "",
        status: "",
        start_date: "",
        end_date: "",
        region: "",
        external_link: "",
        keywords: "",
        description: "",
        observation: "",
        finished_message: "",
      },
      requiredFields: ["name", "status", "start_date"],
      status: [
        {
          key: "open",
          value: "Regular",
          description:
            "Uma seleção regular fica visível e aceita novas inscrições.",
        },
        {
          key: "closed",
          value: "Encerrada",
          description:
            "Uma seleção encerrada não aceita inscrições. O status 'Encerrada' será exibido.",
        },
        {
          key: "hidden",
          value: "Invisível",
          description:
            "Uma selação invisível fica oculta e não aceita inscrições.",
        },
      ],
      modals: {
        confirmation: false,
      },
      error: "",
    };
  },
  methods: {
    async handleSubmit() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_create,
        opacity: 0,
        width: 140,
        height: 140,
      });
      const data = this.model;
      try {
        await api.post("/adm/recruitment-processes", data);
        this.$toasted.show("Nova seleção cadastrada com sucesso");
        this.$router.push("/admin/selecoes");
      } catch (e) {
        this.error = "Ocorreu um erro ao salvar a seleção. Tente novamente.";
        this.$toasted.error("Ocorreu um erro ao salvar as informações");
        this.modals.confirmation = false;
      }
      loader.hide();
    },
    handleOpenModalConfirmation() {
      this.error = "";
      const data = this.model;
      for (const key of this.requiredFields) {
        if (data[key] === "") {
          this.error =
            "Por favor, preencha todos os campos obrigatórios para prosseguir.";
          return;
        }
      }
      this.modals.confirmation = true;
    },
    setCurrentDate() {
      this.model.start_date = this.moment().format("YYYY-MM-DD");
    },
    calcDuration() {
      if (this.model.start_date && this.model.end_date) {
        const d1 = this.moment(this.model.start_date);
        const d2 = this.moment(this.model.end_date);
        let diffDays = d2.diff(d1, "days");
        if (diffDays <= 0)
          return "* Data fim deve ser maior que data de início";
        return `* Duração da chamada: ${diffDays} dias`;
      }
    },
  },
  computed: {
    getStatusDescription() {
      const selectedStatus = this.status.find(
        (status) => status.key === this.model.status
      );
      return selectedStatus ? selectedStatus.description : "";
    },
    getStatusName() {
      const selectedStatus = this.status.find(
        (status) => status.key === this.model.status
      );
      return selectedStatus ? selectedStatus.value : "-";
    },
  },
};
</script>
<style scoped>
.input-unit-box {
  position: relative;
}

.input-unit {
  display: block;
  border: 1px solid #d7d6d6;
  background: #fff;
  padding: 10px 10px 10px 30px;
}

.unit {
  position: absolute;
  display: block;
  left: 5px;
  top: 10px;
  z-index: 9;
  color: #444444;
}

.duration {
  text-transform: uppercase;
  font-size: 12px;
  color: #444444;
}

.duration,
.tag {
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
}

.tag {
  font-size: 18px;
  margin-left: 1em;
  color: black;
}

.tag-title {
  margin-bottom: 1.2em;
}
</style>
